import * as React from 'react';

import { LocalizedComponentProps } from 'bernie-l10n';
import { ViewLarge, Viewport, ViewSmall } from 'bernie-view';
import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';

import { UitkPill } from 'uitk-react-pill';
import { UitkSheet } from 'uitk-react-sheet';
import { UitkExpandoPeek } from 'uitk-react-expando';

import { ReviewsFilterOptions } from 'components/infosite/property-details/reviews-filter-options.tsx';

import { ReviewsFilterOptionsModel } from 'models/common';
import { CollapseHeight } from 'constants/collapse-height';

export interface ReviewsFilterProps extends LocalizedComponentProps {
  className?: string;
  applyReviewsFilter?: (values, shouldFetch) => void;
  checkboxOptions?: ReviewsFilterOptionsModel[];
  radioOptions?: ReviewsFilterOptionsModel[];
  countSelected?: number;
  label?: string;
  showSheet?: boolean;
  toggleSheet?: () => void;
  radioGroupName?: string;
  reviewLanguageFilters?: string;
  isDateless?: boolean;
}

export class ReviewsFilter extends React.Component<ReviewsFilterProps> {
  public constructor(props) {
    super(props);

    this.setFilters = this.setFilters.bind(this);
  }

  public componentWillUnmount() {
    const { applyReviewsFilter } = this.props;

    if (applyReviewsFilter) {
      applyReviewsFilter([], false);
    }
  }

  public setFilters(scoreFilters) {
    const { applyReviewsFilter, toggleSheet } = this.props;

    if (applyReviewsFilter) {
      applyReviewsFilter(scoreFilters, true);
    }

    if (toggleSheet) {
      toggleSheet();
    }
  }

  public render() {
    const {
      countSelected,
      className,
      checkboxOptions,
      label,
      showSheet,
      toggleSheet,
      radioGroupName,
      radioOptions,
      reviewLanguageFilters,
      isDateless
    } = this.props;
    const showActive = countSelected > 0;
    const countToDisplay = showActive ? ` (${countSelected})` : '';

    if (!isDateless) {
      return (
        <DefaultReviewFilter
          className={className}
          checkboxOptions={checkboxOptions}
          label={label}
          showSheet={showSheet}
          toggleSheet={toggleSheet}
          showActive={showActive}
          setFilters={this.setFilters}
          countToDisplay={countToDisplay}
        />
      );
    }

    return (
      <AbacusExperiment name="PWA_HIS_DATELESS_PDP_Reviews_language_filter">
        <AbacusControl>
          <DefaultReviewFilter
            className={className}
            checkboxOptions={checkboxOptions}
            label={label}
            showSheet={showSheet}
            toggleSheet={toggleSheet}
            showActive={showActive}
            setFilters={this.setFilters}
            countToDisplay={countToDisplay}
          />
        </AbacusControl>
        <AbacusVariant bucket={1}>
          <span className={className}>
            <Viewport>
              <ViewSmall>
                <>
                  <span className="all-cell-shrink" onClick={toggleSheet}>
                    <UitkPill checked={!showSheet && showActive} triggerPill={true} className="all-b-padding-six" active={showSheet}>
                      <span className="all-r-padding-two">{label + countToDisplay}</span>
                    </UitkPill>
                  </span>
                  <UitkSheet isVisible={showSheet} className="uitk-grid m-x-padding-three uitk-scroll-vertical">
                    {showSheet && (
                      <ReviewsFilterOptions
                        showButtons={true}
                        applyOptionsCallback={this.setFilters}
                        className="all-cell-fill"
                        checkboxOptions={checkboxOptions}
                        label={label}
                        radioGroupName={radioGroupName}
                        radioOptions={radioOptions}
                        reviewLanguageFilters={reviewLanguageFilters}
                        toggleSheet={toggleSheet}
                      />
                    )}
                  </UitkSheet>
                </>
              </ViewSmall>
              <ViewLarge>
                <UitkExpandoPeek collapseHeight={CollapseHeight.FOUR_HEIGHT}>
                  <ReviewsFilterOptions
                    showButtons={false}
                    applyOptionsCallback={this.setFilters}
                    checkboxOptions={checkboxOptions}
                    label={label}
                    radioGroupName={radioGroupName}
                    radioOptions={radioOptions}
                  />
                </UitkExpandoPeek>
              </ViewLarge>
            </Viewport>
          </span>
        </AbacusVariant>
      </AbacusExperiment>
    );
  }
}

export interface DefaultReviewFilterProps {
  className?: string;
  checkboxOptions?: ReviewsFilterOptionsModel[];
  label?: string;
  showSheet?: boolean;
  showActive?: boolean;
  toggleSheet?: () => void;
  setFilters?: (values) => void;
  countToDisplay?: string;
}

export const DefaultReviewFilter: React.FunctionComponent<DefaultReviewFilterProps> = props => {
  const {
    className,
    checkboxOptions,
    label,
    showSheet,
    toggleSheet,
    showActive,
    setFilters,
    countToDisplay
  } = props;

  if (!checkboxOptions) { return null; }

  return (
    <span className={className}>
      <Viewport>
        <ViewSmall>
          <>
            <span className="all-cell-shrink" onClick={toggleSheet}>
              <UitkPill checked={!showSheet && showActive} triggerPill={true} className="all-b-padding-six" active={showSheet}>
                <span className="all-r-padding-two">{label + countToDisplay}</span>
              </UitkPill>
            </span>
            <UitkSheet isVisible={showSheet} className="uitk-grid m-x-padding-three uitk-scroll-vertical">
              {showSheet && (
                <ReviewsFilterOptions
                  showButtons={true}
                  applyOptionsCallback={setFilters}
                  className="all-cell-fill"
                  checkboxOptions={checkboxOptions}
                  label={label}
                  toggleSheet={toggleSheet}
                />
              )}
            </UitkSheet>
          </>
        </ViewSmall>
        <ViewLarge>
          <ReviewsFilterOptions
            showButtons={false}
            applyOptionsCallback={setFilters}
            checkboxOptions={checkboxOptions}
            label={label}
          />
        </ViewLarge>
      </Viewport>
    </span>
  );
};
DefaultReviewFilter.displayName = 'DefaultReviewFilter';
